<app-page-title [heading]="heading" [subheading]="subheading" [icon]="icon"></app-page-title>

<div class="row mb-3">
  <div class="col-md-12">
    <div class="main-card mb-3 card">
      <div class="card-body"><h5 class="card-title">Gradient Icons</h5>
        <div class="font-icon-wrapper font-icon-lg"><i class="pe-7s-filter icon-gradient bg-warm-flame"> </i></div>
        <div class="font-icon-wrapper font-icon-lg"><i class="pe-7s-help1 icon-gradient bg-night-fade"> </i></div>
        <div class="font-icon-wrapper font-icon-lg"><i class="pe-7s-moon icon-gradient bg-sunny-morning"> </i></div>
        <div class="font-icon-wrapper font-icon-lg"><i class="pe-7s-plane icon-gradient bg-tempting-azure"> </i></div>
        <div class="font-icon-wrapper font-icon-lg"><i class="pe-7s-box2 icon-gradient bg-amy-crisp"> </i></div>
        <div class="font-icon-wrapper font-icon-lg"><i class="pe-7s-lock icon-gradient bg-malibu-beach"> </i></div>
        <div class="font-icon-wrapper font-icon-lg"><i class="pe-7s-monitor icon-gradient bg-mean-fruit"> </i></div>
        <div class="font-icon-wrapper font-icon-lg"><i class="pe-7s-mouse icon-gradient bg-heavy-rain"> </i></div>
        <div class="font-icon-wrapper font-icon-lg"><i class="pe-7s-paint icon-gradient bg-arielle-smile"> </i></div>
        <div class="font-icon-wrapper font-icon-lg"><i class="pe-7s-menu icon-gradient bg-ripe-malin"> </i></div>
        <div class="font-icon-wrapper font-icon-lg"><i class="pe-7s-wristwatch icon-gradient bg-deep-blue"> </i></div>
        <div class="font-icon-wrapper font-icon-lg"><i class="pe-7s-volume2 icon-gradient bg-happy-itmeo"> </i></div>
        <div class="font-icon-wrapper font-icon-lg"><i class="pe-7s-video icon-gradient bg-happy-fisher"> </i></div>
        <div class="font-icon-wrapper font-icon-lg"><i class="pe-7s-wallet icon-gradient bg-plum-plate"> </i></div>
        <div class="font-icon-wrapper font-icon-lg"><i class="pe-7s-paint-bucket icon-gradient bg-grow-early"> </i></div>
        <div class="font-icon-wrapper font-icon-lg"><i class="pe-7s-diamond icon-gradient bg-strong-bliss"> </i></div>
        <div class="font-icon-wrapper font-icon-lg"><i class="pe-7s-magic-wand icon-gradient bg-mixed-hopes"> </i></div>
        <div class="font-icon-wrapper font-icon-lg"><i class="pe-7s-arc icon-gradient bg-premium-dark"> </i></div>
        <div class="font-icon-wrapper font-icon-lg"><i class="pe-7s-hourglass icon-gradient bg-love-kiss"> </i></div>
      </div>
    </div>
  </div>
  <div class="col-md-12">
    <div class="main-card mb-3 card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-album"> </i>
              <p>pe-7s-album</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-arc"> </i>
              <p>pe-7s-arc</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-back-2"> </i>
              <p>pe-7s-back-2</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-bandaid"> </i>
              <p>pe-7s-bandaid</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-car"> </i>
              <p>pe-7s-car</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-diamond"> </i>
              <p>pe-7s-diamond</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-door-lock"> </i>
              <p>pe-7s-door-lock</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-eyedropper"> </i>
              <p>pe-7s-eyedropper</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-female"> </i>
              <p>pe-7s-female</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-gym"> </i>
              <p>pe-7s-gym</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-hammer"> </i>
              <p>pe-7s-hammer</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-headphones"> </i>
              <p>pe-7s-headphones</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-helm"> </i>
              <p>pe-7s-helm</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-hourglass"> </i>
              <p>pe-7s-hourglass</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-leaf"> </i>
              <p>pe-7s-leaf</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-magic-wand"> </i>
              <p>pe-7s-magic-wand</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-male"> </i>
              <p>pe-7s-male</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-map-2"> </i>
              <p>pe-7s-map-2</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-next-2"> </i>
              <p>pe-7s-next-2</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-paint-bucket"> </i>
              <p>pe-7s-paint-bucket</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-pendrive"> </i>
              <p>pe-7s-pendrive</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-photo"> </i>
              <p>pe-7s-photo</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-piggy"> </i>
              <p>pe-7s-piggy</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-plugin"> </i>
              <p>pe-7s-plugin</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-refresh-2"> </i>
              <p>pe-7s-refresh-2</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-rocket"> </i>
              <p>pe-7s-rocket</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-settings"> </i>
              <p>pe-7s-settings</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-shield"> </i>
              <p>pe-7s-shield</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-smile"> </i>
              <p>pe-7s-smile</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-usb"> </i>
              <p>pe-7s-usb</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-vector"> </i>
              <p>pe-7s-vector</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-wine"> </i>
              <p>pe-7s-wine</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-cloud-upload"> </i>
              <p>pe-7s-cloud-upload</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-cash"> </i>
              <p>pe-7s-cash</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-close"> </i>
              <p>pe-7s-close</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-bluetooth"> </i>
              <p>pe-7s-bluetooth</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-cloud-download"> </i>
              <p>pe-7s-cloud-download</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-way"> </i>
              <p>pe-7s-way</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-close-circle"> </i>
              <p>pe-7s-close-circle</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-id"> </i>
              <p>pe-7s-id</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-angle-up"> </i>
              <p>pe-7s-angle-up</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-wristwatch"> </i>
              <p>pe-7s-wristwatch</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-angle-up-circle"> </i>
              <p>pe-7s-angle-up-circle</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-world"> </i>
              <p>pe-7s-world</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-angle-right"> </i>
              <p>pe-7s-angle-right</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-volume"> </i>
              <p>pe-7s-volume</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-angle-right-circle"> </i>
              <p>pe-7s-angle-right-circle</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-users"> </i>
              <p>pe-7s-users</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-angle-left"> </i>
              <p>pe-7s-angle-left</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-user-female"> </i>
              <p>pe-7s-user-female</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-angle-left-circle"> </i>
              <p>pe-7s-angle-left-circle</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-up-arrow"> </i>
              <p>pe-7s-up-arrow</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-angle-down"> </i>
              <p>pe-7s-angle-down</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-switch"> </i>
              <p>pe-7s-switch</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-angle-down-circle"> </i>
              <p>pe-7s-angle-down-circle</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-scissors"> </i>
              <p>pe-7s-scissors</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-wallet"> </i>
              <p>pe-7s-wallet</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-safe"> </i>
              <p>pe-7s-safe</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-volume2"> </i>
              <p>pe-7s-volume2</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-volume1"> </i>
              <p>pe-7s-volume1</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-voicemail"> </i>
              <p>pe-7s-voicemail</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-video"> </i>
              <p>pe-7s-video</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-user"> </i>
              <p>pe-7s-user</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-upload"> </i>
              <p>pe-7s-upload</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-unlock"> </i>
              <p>pe-7s-unlock</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-umbrella"> </i>
              <p>pe-7s-umbrella</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-trash"> </i>
              <p>pe-7s-trash</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-tools"> </i>
              <p>pe-7s-tools</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-timer"> </i>
              <p>pe-7s-timer</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-ticket"> </i>
              <p>pe-7s-ticket</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-target"> </i>
              <p>pe-7s-target</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-sun"> </i>
              <p>pe-7s-sun</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-study"> </i>
              <p>pe-7s-study</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-stopwatch"> </i>
              <p>pe-7s-stopwatch</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-star"> </i>
              <p>pe-7s-star</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-speaker"> </i>
              <p>pe-7s-speaker</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-signal"> </i>
              <p>pe-7s-signal</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-shuffle"> </i>
              <p>pe-7s-shuffle</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-shopbag"> </i>
              <p>pe-7s-shopbag</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-share"> </i>
              <p>pe-7s-share</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-server"> </i>
              <p>pe-7s-server</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-search"> </i>
              <p>pe-7s-search</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-film"> </i>
              <p>pe-7s-film</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-science"> </i>
              <p>pe-7s-science</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-disk"> </i>
              <p>pe-7s-disk</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-ribbon"> </i>
              <p>pe-7s-ribbon</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-repeat"> </i>
              <p>pe-7s-repeat</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-refresh"> </i>
              <p>pe-7s-refresh</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-add-user"> </i>
              <p>pe-7s-add-user</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-refresh-cloud"> </i>
              <p>pe-7s-refresh-cloud</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-paperclip"> </i>
              <p>pe-7s-paperclip</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-radio"> </i>
              <p>pe-7s-radio</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-note2"> </i>
              <p>pe-7s-note2</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-print"> </i>
              <p>pe-7s-print</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-network"> </i>
              <p>pe-7s-network</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-prev"> </i>
              <p>pe-7s-prev</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-mute"> </i>
              <p>pe-7s-mute</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-power"> </i>
              <p>pe-7s-power</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-medal"> </i>
              <p>pe-7s-medal</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-portfolio"> </i>
              <p>pe-7s-portfolio</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-like2"> </i>
              <p>pe-7s-like2</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-plus"> </i>
              <p>pe-7s-plus</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-left-arrow"> </i>
              <p>pe-7s-left-arrow</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-play"> </i>
              <p>pe-7s-play</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-key"> </i>
              <p>pe-7s-key</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-plane"> </i>
              <p>pe-7s-plane</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-joy"> </i>
              <p>pe-7s-joy</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-photo-gallery"> </i>
              <p>pe-7s-photo-gallery</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-pin"> </i>
              <p>pe-7s-pin</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-phone"> </i>
              <p>pe-7s-phone</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-plug"> </i>
              <p>pe-7s-plug</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-pen"> </i>
              <p>pe-7s-pen</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-right-arrow"> </i>
              <p>pe-7s-right-arrow</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-paper-plane"> </i>
              <p>pe-7s-paper-plane</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-delete-user"> </i>
              <p>pe-7s-delete-user</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-paint"> </i>
              <p>pe-7s-paint</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-bottom-arrow"> </i>
              <p>pe-7s-bottom-arrow</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-notebook"> </i>
              <p>pe-7s-notebook</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-note"> </i>
              <p>pe-7s-note</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-next"> </i>
              <p>pe-7s-next</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-news-paper"> </i>
              <p>pe-7s-news-paper</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-musiclist"> </i>
              <p>pe-7s-musiclist</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-music"> </i>
              <p>pe-7s-music</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-mouse"> </i>
              <p>pe-7s-mouse</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-more"> </i>
              <p>pe-7s-more</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-moon"> </i>
              <p>pe-7s-moon</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-monitor"> </i>
              <p>pe-7s-monitor</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-micro"> </i>
              <p>pe-7s-micro</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-menu"> </i>
              <p>pe-7s-menu</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-map"> </i>
              <p>pe-7s-map</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-map-marker"> </i>
              <p>pe-7s-map-marker</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-mail"> </i>
              <p>pe-7s-mail</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-mail-open"> </i>
              <p>pe-7s-mail-open</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-mail-open-file"> </i>
              <p>pe-7s-mail-open-file</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-magnet"> </i>
              <p>pe-7s-magnet</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-loop"> </i>
              <p>pe-7s-loop</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-look"> </i>
              <p>pe-7s-look</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-lock"> </i>
              <p>pe-7s-lock</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-lintern"> </i>
              <p>pe-7s-lintern</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-link"> </i>
              <p>pe-7s-link</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-like"> </i>
              <p>pe-7s-like</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-light"> </i>
              <p>pe-7s-light</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-less"> </i>
              <p>pe-7s-less</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-keypad"> </i>
              <p>pe-7s-keypad</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-junk"> </i>
              <p>pe-7s-junk</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-info"> </i>
              <p>pe-7s-info</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-home"> </i>
              <p>pe-7s-home</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-help2"> </i>
              <p>pe-7s-help2</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-help1"> </i>
              <p>pe-7s-help1</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-graph3"> </i>
              <p>pe-7s-graph3</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-graph2"> </i>
              <p>pe-7s-graph2</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-graph1"> </i>
              <p>pe-7s-graph1</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-graph"> </i>
              <p>pe-7s-graph</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-global"> </i>
              <p>pe-7s-global</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-gleam"> </i>
              <p>pe-7s-gleam</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-glasses"> </i>
              <p>pe-7s-glasses</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-gift"> </i>
              <p>pe-7s-gift</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-folder"> </i>
              <p>pe-7s-folder</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-flag"> </i>
              <p>pe-7s-flag</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-filter"> </i>
              <p>pe-7s-filter</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-file"> </i>
              <p>pe-7s-file</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-expand1"> </i>
              <p>pe-7s-expand1</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-exapnd2"> </i>
              <p>pe-7s-exapnd2</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-edit"> </i>
              <p>pe-7s-edit</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-drop"> </i>
              <p>pe-7s-drop</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-drawer"> </i>
              <p>pe-7s-drawer</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-download"> </i>
              <p>pe-7s-download</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-display2"> </i>
              <p>pe-7s-display2</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-display1"> </i>
              <p>pe-7s-display1</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-diskette"> </i>
              <p>pe-7s-diskette</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-date"> </i>
              <p>pe-7s-date</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-cup"> </i>
              <p>pe-7s-cup</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-culture"> </i>
              <p>pe-7s-culture</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-crop"> </i>
              <p>pe-7s-crop</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-credit"> </i>
              <p>pe-7s-credit</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-copy-file"> </i>
              <p>pe-7s-copy-file</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-config"> </i>
              <p>pe-7s-config</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-compass"> </i>
              <p>pe-7s-compass</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-comment"> </i>
              <p>pe-7s-comment</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-coffee"> </i>
              <p>pe-7s-coffee</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-cloud"> </i>
              <p>pe-7s-cloud</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-clock"> </i>
              <p>pe-7s-clock</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-check"> </i>
              <p>pe-7s-check</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-chat"> </i>
              <p>pe-7s-chat</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-cart"> </i>
              <p>pe-7s-cart</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-camera"> </i>
              <p>pe-7s-camera</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-call"> </i>
              <p>pe-7s-call</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-calculator"> </i>
              <p>pe-7s-calculator</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-browser"> </i>
              <p>pe-7s-browser</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-box2"> </i>
              <p>pe-7s-box2</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-box1"> </i>
              <p>pe-7s-box1</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-bookmarks"> </i>
              <p>pe-7s-bookmarks</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-bicycle"> </i>
              <p>pe-7s-bicycle</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-bell"> </i>
              <p>pe-7s-bell</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-battery"> </i>
              <p>pe-7s-battery</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-ball"> </i>
              <p>pe-7s-ball</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-back"> </i>
              <p>pe-7s-back</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-attention"> </i>
              <p>pe-7s-attention</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-anchor"> </i>
              <p>pe-7s-anchor</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-albums"> </i>
              <p>pe-7s-albums</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-alarm"> </i>
              <p>pe-7s-alarm</p></div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="pe-7s-airplay"> </i>
              <p>pe-7s-airplay</p></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-md-12">
    <div class="main-card mb-3 card">
      <div class="card-body"><h5 class="card-title">Gradient Icons</h5>
        <div class="font-icon-wrapper font-icon-lg"><i class="fa fa-ambulance icon-gradient bg-warm-flame"> </i></div>
        <div class="font-icon-wrapper font-icon-lg"><i class="fa fa-volume-up icon-gradient bg-night-fade"> </i></div>
        <div class="font-icon-wrapper font-icon-lg"><i class="fa fa-archive icon-gradient bg-sunny-morning"> </i></div>
        <div class="font-icon-wrapper font-icon-lg"><i class="fa fa-binoculars icon-gradient bg-tempting-azure"> </i></div>
        <div class="font-icon-wrapper font-icon-lg"><i class="fa fa-certificate icon-gradient bg-amy-crisp"> </i></div>
        <div class="font-icon-wrapper font-icon-lg"><i class="fa fa-download icon-gradient bg-malibu-beach"> </i></div>
        <div class="font-icon-wrapper font-icon-lg"><i class="fa fa-cog icon-gradient bg-mean-fruit"> </i></div>
        <div class="font-icon-wrapper font-icon-lg"><i class="fa fa-fire-extinguisher icon-gradient bg-heavy-rain"> </i></div>
        <div class="font-icon-wrapper font-icon-lg"><i class="fa fa-hammer icon-gradient bg-arielle-smile"> </i></div>
        <div class="font-icon-wrapper font-icon-lg"><i class="fa fa-database icon-gradient bg-ripe-malin"> </i></div>
        <div class="font-icon-wrapper font-icon-lg"><i class="fa fa-exclamation icon-gradient bg-deep-blue"> </i></div>
        <div class="font-icon-wrapper font-icon-lg"><i class="fa fa-file-archive icon-gradient bg-happy-itmeo"> </i></div>
        <div class="font-icon-wrapper font-icon-lg"><i class="fa fa-gavel icon-gradient bg-happy-fisher"> </i></div>
        <div class="font-icon-wrapper font-icon-lg"><i class="fa fa-crosshairs icon-gradient bg-plum-plate"> </i></div>
        <div class="font-icon-wrapper font-icon-lg"><i class="fa fa-deskpro icon-gradient bg-grow-early"> </i></div>
        <div class="font-icon-wrapper font-icon-lg"><i class="fa fa-satellite icon-gradient bg-strong-bliss"> </i></div>
        <div class="font-icon-wrapper font-icon-lg"><i class="fa fa-keyboard icon-gradient bg-mixed-hopes"> </i></div>
        <div class="font-icon-wrapper font-icon-lg"><i class="fa fa-gamepad icon-gradient bg-premium-dark"> </i></div>
        <div class="font-icon-wrapper font-icon-lg"><i class="fa fa-ship icon-gradient bg-love-kiss"> </i></div>
      </div>
    </div>
  </div>
  <div class="col-md-12">
    <div class="main-card mb-3 card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="address-book"></i>
              <p>fa-address-book</p>
            </div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="address-card"></i>
              <p>fa-address-card</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="adjust"></i>
              <p>fa-adjust</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="align-center"></i>
              <p>fa-align-center</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="align-justify"></i>
              <p>fa-align-justify</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="align-left"></i>
              <p>fa-align-left</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="align-right"></i>
              <p>fa-align-right</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="ambulance"></i>
              <p>fa-ambulance</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="american-sign-language-interpreting"></i>
              <p>fa-american-sign-language-interpreting</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="anchor"></i>
              <p>fa-anchor</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="angle-double-down"></i>
              <p>fa-angle-double-down</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="angle-double-left"></i>
              <p>fa-angle-double-left</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="angle-double-right"></i>
              <p>fa-angle-double-right</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="angle-double-up"></i>
              <p>fa-angle-double-up</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="angle-down"></i>
              <p>fa-angle-down</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="angle-left"></i>
              <p>fa-angle-left</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="angle-right"></i>
              <p>fa-angle-right</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="angle-up"></i>
              <p>fa-angle-up</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="archive"></i>
              <p>fa-archive</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="area-chart"></i>
              <p>fa-area-chart</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="arrow-circle-down"></i>
              <p>fa-arrow-circle-down</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="arrow-circle-left"></i>
              <p>fa-arrow-circle-left</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="arrow-circle-right"></i>
              <p>fa-arrow-circle-right</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="arrow-circle-up"></i>
              <p>fa-arrow-circle-up</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="arrow-down"></i>
              <p>fa-arrow-down</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="arrow-left"></i>
              <p>fa-arrow-left</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="arrow-right"></i>
              <p>fa-arrow-right</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="arrow-up"></i>
              <p>fa-arrow-up</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="arrows-alt"></i>
              <p>fa-arrows-alt</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="asl-interpreting"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="assistive-listening-systems"></i>
              <p>fa-assistive-listening-systems</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="asterisk"></i>
              <p>fa-asterisk</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="at"></i>
              <p>fa-at</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="audio-description"></i>
              <p>fa-audio-description</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="automobile"></i>
              <p>fa-automobile</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="backward"></i>
              <p>fa-backward</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="balance-scale"></i>
              <p>fa-balance-scale</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="ban"></i>
              <p>fa-ban</p>
            </div>
          </div>


          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="bank"></i>
              <p>fa-bank</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="bar-chart"></i>
              <p>fa-bar-chart</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="bar-chart-o"></i>
              <p>fa-chart-o</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="barcode"></i>
              <p>fa-barcode</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="bars"></i>
              <p>fa-bars</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="bathtub"></i>
              <p>fa-bathtub</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="battery"></i>
              <p>fa-fw</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="battery-0"></i>
              <p>fa-battery-0</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="battery-1"></i>
              <p>fa-battery-1</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="battery-2"></i>
              <p>fa-battery-2</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="battery-3"></i>
              <p>fa-battery-3</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="battery-4"></i>
              <p>fa-battery-4</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="battery-empty"></i>
              <p>fa-battery-empty</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="battery-full"></i>
              <p>fa-battery-full</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="battery-half"></i>
              <p>fa-battery-half</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="battery-quarter"></i>
              <p>fa-battery-quarter</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="battery-three-quarters"></i>
              <p>fa-battery-three-quarters</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="bed"></i>
              <p>fa-bed</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="beer"></i>
              <p>fa-beer</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="bell"></i>
              <p>fa-bell</p>
            </div>
          </div>


          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="bell-slash"></i>
              <p>fa-bell-slash</p>
            </div>
          </div>


          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="bicycle"></i>
              <p>fa-bicycle</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="binoculars"></i>
              <p>fa-binoculars</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="birthday-cake"></i>
              <p>fa-birthday-cake</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="blind"></i>
              <p>fa-blind</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="bold"></i>
              <p>fa-bold</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="bolt"></i>
              <p>fa-bolt</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="bomb"></i>
              <p>fa-bomb</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="book"></i>
              <p>fa-book</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="bookmark"></i>
              <p>fa-bookmark</p>
            </div>
          </div>


          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="braille"></i>
              <p>fa-braille</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="briefcase"></i>
              <p>fa-briefcase</p>
            </div>
          </div>


          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="bug"></i>
              <p>fa-bug</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="building"></i>
              <p>fa-building</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="bullhorn"></i>
              <p>fa-bullhorn</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="bullseye"></i>
              <p>fa-bullseye</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="bus"></i>
              <p>fa-bus</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="cab"></i>
              <p>fa-cab</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="calculator"></i>
              <p>fa-calculator</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="calendar"></i>
              <p>fa-calendar</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="calendar-check-o"></i>
              <p>fa-calendar-check-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="calendar-minus-o"></i>
              <p>fa-calendar-minus-o</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="calendar-o"></i>
              <p>fa-calendar-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="calendar-plus-o"></i>
              <p>fa-calendar-plus-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="calendar-times-o"></i>
              <p>fa-calendar-times-o</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="camera"></i>
              <p>fa-camera</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="camera-retro"></i>
              <p>fa-camera-retro</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="car"></i>
              <p>fa-car</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="caret-down"></i>
              <p>fa-caret-down</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="caret-left"></i>
              <p>fa-caret-left</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="caret-right"></i>
              <p>fa-caret-right</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="caret-square-o-down"></i>
              <p>fa-caret-square-o-down</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="caret-square-o-left"></i>
              <p>fa-caret-square-o-left</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="caret-square-o-right"></i>
              <p>fa-caret-square-o-right</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="caret-square-o-up"></i>
              <p>fa-caret-square-o-up</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="caret-up"></i>
              <p>fa-caret-up</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="cart-arrow-down"></i>
              <p>fa-cart-arrow-down</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="cart-plus"></i>
              <p>fa-cart-plus</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="cc"></i>
              <p>fa-cc</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="certificate"></i>
              <p>fa-certificate</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="chain"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="chain-broken"></i>
              <p>fa-chain-broken</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="check"></i>
              <p>fa-check</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="check-circle"></i>
              <p>fa-check-circle</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="check-square"></i>
              <p>fa-check-square</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="chevron-circle-down"></i>
              <p>fa-chevron-circle-down</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="chevron-circle-left"></i>
              <p>fa-chevron-circle-left</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="chevron-circle-right"></i>
              <p>fa-chevron-circle-right</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="chevron-circle-up"></i>
              <p>fa-chevron-circle-up</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="chevron-down"></i>
              <p>fa-chevron-down</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="chevron-left"></i>
              <p>fa-chevron-left</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="chevron-right"></i>
              <p>fa-chevron-right</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="chevron-up"></i>
              <p>fa-chevron-up</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="child"></i>
              <p>fa-child</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="circle"></i>
              <p>fa-circle</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="clipboard"></i>
              <p>fa-clipboard</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="clock-o"></i>
              <p>fa-clock-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="clone"></i>
              <p>fa-clone</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="close"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="cloud"></i>
              <p>fa-cloud</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="cny"></i>
              <p>fa-times</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="code"></i>
              <p>fa-code</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="code-fork"></i>
              <p>fa-code-fork</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="coffee"></i>
              <p>fa-coffee</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="cog"></i>
              <p>fa-cog</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="cogs"></i>
              <p>fa-cogs</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="columns"></i>
              <p>fa-columns</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="comment"></i>
              <p>fa-comment</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="commenting"></i>
              <p>fa-commenting</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="comments"></i>
              <p>fa-comments</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="compass"></i>
              <p>fa-compass</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="compress"></i>
              <p>fa-compress</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="copy"></i>
              <p>fa-copy</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="copyright"></i>
              <p>fa-copyright</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="credit-card"></i>
              <p>fa-credit-card</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="crop"></i>
              <p>fa-crop</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="crosshairs"></i>
              <p>fa-crosshairs</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="cube"></i>
              <p>fa-cube</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="cubes"></i>
              <p>fa-cubes</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="cut"></i>
              <p>fa-cut</p>
            </div>
          </div>


          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="database"></i>
              <p>fa-database</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="deaf"></i>
              <p>fa-deaf</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="deafness"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="desktop"></i>
              <p>fa-desktop</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="dollar"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="dot-circle-o"></i>
              <p>fa-dot-circle-o</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="download"></i>
              <p>fa-download</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="drivers-license"></i>
              <p>fa-drivers-license</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="edit"></i>
              <p>fa-edit</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="eject"></i>
              <p>fa-eject</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="ellipsis-h"></i>
              <p>fa-ellipsis-h</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="ellipsis-v"></i>
              <p>fa-ellipsis-v</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="envelope"></i>
              <p>fa-envelope</p>
            </div>
          </div>


          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="envelope-open"></i>
              <p>fa-envelope-open</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="envelope-square"></i>
              <p>fa-envelope-square</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="eraser"></i>
              <p>fa-eraser</p>
            </div>
          </div>


          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="eur"></i>
              <p>fa-eur</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="euro"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="exclamation"></i>
              <p>fa-exclamation</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="exclamation-circle"></i>
              <p>fa-exclamation-circle</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="exclamation-triangle"></i>
              <p>fa-exclamation-triangle</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="expand"></i>
              <p>fa-expand</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="eye"></i>
              <p>fa-eye</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="eye-slash"></i>
              <p>fa-eye-slash</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="eyedropper"></i>
              <p>fa-eyedropper</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="fast-backward"></i>
              <p>fa-fast-backward</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="fast-forward"></i>
              <p>fa-fast-forward</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="fax"></i>
              <p>fa-fax</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="feed"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="female"></i>
              <p>fa-female</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="fighter-jet"></i>
              <p>fa-fighter-jet</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="file"></i>
              <p>fa-file</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="file-archive-o"></i>
              <p>fa-file-archive-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="file-audio-o"></i>
              <p>fa-file-audio-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="file-code-o"></i>
              <p>fa-file-code-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="file-excel-o"></i>
              <p>fa-file-excel-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="file-image-o"></i>
              <p>fa-file-image-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="file-movie-o"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="file-pdf-o"></i>
              <p>fa-file-pdf-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="file-photo-o"></i>
              <p>fa-file-photo-0</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="file-picture-o"></i>
              <p>fa-picture-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="file-powerpoint-o"></i>
              <p>fa-file-powerpoint-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="file-sound-o"></i>
              <p>fa-file-sound-o</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="file-text"></i>
              <p>fa-file-text</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="file-video-o"></i>
              <p>fa-file-video-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="file-word-o"></i>
              <p>fa-file-word-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="file-zip-o"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="files-o"></i>
              <p>fa-files-o</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="film"></i>
              <p>fa-film</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="filter"></i>
              <p>fa-filter</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="fire"></i>
              <p>fa-fire</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="fire-extinguisher"></i>
              <p>fa-fire-extinguisher</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="firefox"></i>
              <p>fa-firefox</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="first-order"></i>
              <p>fa-first-order</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="flag"></i>
              <p>fa-flag</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="flag-checkered"></i>
              <p>fa-flag-checkered</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="flask"></i>
              <p>fa-flask</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="floppy-o"></i>
              <p>fa-floppy-o</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="folder"></i>
              <p>fa-folder</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="folder-o"></i>
              <p>fa-folder-o</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="folder-open"></i>
              <p>fa-folder-open</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="folder-open-o"></i>
              <p>fa-folder-open-o</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="font"></i>
              <p>fa-font</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="font-awesome"></i>
              <p>fa-font-awesome</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="fonticons"></i>
              <p>fa-fonticons</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="fort-awesome"></i>
              <p>fa-fort-awesome</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="forumbee"></i>
              <p>fa-forumbee</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="forward"></i>
              <p>fa-forward</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="foursquare"></i>
              <p>fa-foursquare</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="free-code-camp"></i>
              <p>fa-free-code-camp</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="frown-o"></i>
              <p>fa-frown-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="futbol-o"></i>
              <p>fa-futbol-o</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="gamepad"></i>
              <p>fa-gamepad</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="gavel"></i>
              <p>fa-gavel</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="gbp"></i>
              <p>fa-gbp</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="ge"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="gear"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="gears"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="genderless"></i>
              <p>fa-genderless</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="get-pocket"></i>
              <p>fa-get-pocket</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="gg"></i>
              <p>fa-gg</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="gg-circle"></i>
              <p>fa-gg-circle</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="gift"></i>
              <p>fa-gift</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="git"></i>
              <p>fa-git</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="git-square"></i>
              <p>fa-git-square</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="github"></i>
              <p>fa-github</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="github-alt"></i>
              <p>fa-github-alt</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="github-square"></i>
              <p>fa-github-square</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="gitlab"></i>
              <p>fa-gitlab</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="gittip"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="glass"></i>
              <p>fa-glass</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="glide"></i>
              <p>fa-glide</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="glide-g"></i>
              <p>fa-glide-g</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="globe"></i>
              <p>fa-globe</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="google"></i>
              <p>fa-google</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="google-plus"></i>
              <p>fa-google-plus</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="google-plus-circle"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="google-plus-official"></i>
              <p>fa-google-plus-official</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="google-plus-square"></i>
              <p>fa-google-plus-square</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="google-wallet"></i>
              <p>fa-google-wallet</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="graduation-cap"></i>
              <p>fa-graduation-cap</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="gratipay"></i>
              <p>fa-gratipay</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="grav"></i>
              <p>fa-grav</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="group"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="h-square"></i>
              <p>fa-h-square</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="hacker-news"></i>
              <p>fa-hacker-news</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="hand-grab-o"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="hand-lizard-o"></i>
              <p>fa-hand-lizard-o</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="hand-o-down"></i>
              <p>fa-hand-o-down</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="hand-o-left"></i>
              <p>fa-hand-o-left</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="hand-o-right"></i>
              <p>fa-hand-o-right</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="hand-o-up"></i>
              <p>fa-hand-o-up</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="hand-paper-o"></i>
              <p>fa-hand-paper-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="hand-peace-o"></i>
              <p>fa-hand-peace-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="hand-pointer-o"></i>
              <p>fa-hand-pointer-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="hand-rock-o"></i>
              <p>fa-hand-rock-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="hand-scissors-o"></i>
              <p>fa-hand-scissors-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="hand-spock-o"></i>
              <p>fa-hand-spock-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="hand-stop-o"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="handshake-o"></i>
              <p>fa-handshake-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="hard-of-hearing"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="hashtag"></i>
              <p>fa-hashtag</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="hdd-o"></i>
              <p>fa-hdd-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="header"></i>
              <p>fa-header</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="headphones"></i>
              <p>fa-headphones</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="heart"></i>
              <p>fa-heart</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="heart-o"></i>
              <p>fa-heart-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="heartbeat"></i>
              <p>fa-heartbeat</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="history"></i>
              <p>fa-history</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="home"></i>
              <p>fa-home</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="hospital-o"></i>
              <p>fa-hospital-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="hotel"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="hourglass"></i>
              <p>fa-hourglass</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="hourglass-1"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="hourglass-2"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="hourglass-3"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="hourglass-end"></i>
              <p>fa-hourglass-end</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="hourglass-half"></i>
              <p>fa-hourglass-half</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="hourglass-o"></i>
              <p>fa-hourglass-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="hourglass-start"></i>
              <p>fa-hourglass-start</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="i-cursor"></i>
              <p>fa-i-cursor</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="id-badge"></i>
              <p>fa-id-badge</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="id-card"></i>
              <p>fa-id-card</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="id-card-o"></i>
              <p>fa-id-card-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="ils"></i>
              <p>fa-ils</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="image"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="inbox"></i>
              <p>fa-inbox</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="indent"></i>
              <p>fa-indent</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="industry"></i>
              <p>fa-industry</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="info"></i>
              <p>fa-info</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="info-circle"></i>
              <p>fa-info-circle</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="inr"></i>
              <p>fa-inr</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="instagram"></i>
              <p>fa-instagram</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="institution"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="internet-explorer"></i>
              <p>fa-internet-explorer</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="intersex"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="ioxhost"></i>
              <p>fa-ioxhost</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="italic"></i>
              <p>fa-italic</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="joomla"></i>
              <p>fa-joomla</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="jpy"></i>
              <p>fa-jpy</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="jsfiddle"></i>
              <p>fa-jsfiddle</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="key"></i>
              <p>fa-key</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="keyboard-o"></i>
              <p>fa-keyboard-o</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="krw"></i>
              <p>fa-krw</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="language"></i>
              <p>fa-language</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="laptop"></i>
              <p>fa-laptop</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="lastfm"></i>
              <p>fa-lastfm</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="lastfm-square"></i>
              <p>fa-lastfm-square</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="leaf"></i>
              <p>fa-leaf</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="leanpub"></i>
              <p>fa-leanpub</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="legal"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="lemon-o"></i>
              <p>fa-lemon-o</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="level-down"></i>
              <p>fa-level-down</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="level-up"></i>
              <p>fa-level-up</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="life-bouy"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="life-buoy"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="life-ring"></i>
              <p>fa-life-ring</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="life-saver"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="lightbulb-o"></i>
              <p>fa-lightbulb-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="line-chart"></i>
              <p>fa-line-chart</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="link"></i>
              <p>fa-link</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="linkedin"></i>
              <p>fa-linkedin</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="linkedin-square"></i>
              <p>fa-linkedin-square</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="linode"></i>
              <p>fa-linode</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="linux"></i>
              <p>fa-linux</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="list"></i>
              <p>fa-list</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="list-alt"></i>
              <p>fa-list-alt</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="list-ol"></i>
              <p>fa-list-ol</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="list-ul"></i>
              <p>fa-list-ul</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="location-arrow"></i>
              <p>fa-location-arrow</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="lock"></i>
              <p>fa-lock</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="long-arrow-down"></i>
              <p>fa-long-arrow-down</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="long-arrow-left"></i>
              <p>fa-long-arrow-left</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="long-arrow-right"></i>
              <p>fa-long-arrow-right</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="long-arrow-up"></i>
              <p>fa-long-arrow-up</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="low-vision"></i>
              <p>fa-low-vision</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="magic"></i>
              <p>fa-magic</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="magnet"></i>
              <p>fa-magnet</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="mail-forward"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="mail-reply"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="mail-reply-all"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="male"></i>
              <p>fa-male</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="map"></i>
              <p>fa-map</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="map-marker"></i>
              <p>fa-map-marker</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="map-o"></i>
              <p>fa-map-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="map-pin"></i>
              <p>fa-map-pin</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="map-signs"></i>
              <p>fa-map-signs</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="mars"></i>
              <p>fa-mars</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="mars-double"></i>
              <p>fa-mars-double</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="mars-stroke"></i>
              <p>fa-mars-stroke</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="mars-stroke-h"></i>
              <p>fa-mars-stroke-h</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="mars-stroke-v"></i>
              <p>fa-mars-stroke-v</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="maxcdn"></i>
              <p>fa-maxcdn</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="meanpath"></i>
              <p>fa-meanpath</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="medium"></i>
              <p>fa-medium</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="medkit"></i>
              <p>fa-medkit</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="meetup"></i>
              <p>fa-meetup</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="meh-o"></i>
              <p>fa-meh-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="mercury"></i>
              <p>fa-mercury</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="microchip"></i>
              <p>fa-microchip</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="microphone"></i>
              <p>fa-microphone</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="microphone-slash"></i>
              <p>fa-microphone-slash</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="minus"></i>
              <p>fa-minus</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="minus-circle"></i>
              <p>fa-minus-circle</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="minus-square"></i>
              <p>fa-minus-square</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="minus-square-o"></i>
              <p>fa-minus-square-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="mixcloud"></i>
              <p>fa-mixcloud</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="mobile"></i>
              <p>fa-mobile</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="mobile-phone"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="modx"></i>
              <p>fa-modx</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="money"></i>
              <p>fa-money</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="moon-o"></i>
              <p>fa-moon-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="mortar-board"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="motorcycle"></i>
              <p>fa-motorcycle</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="mouse-pointer"></i>
              <p>fa-mouse-pointer</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="music"></i>
              <p>fa-music</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="navicon"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="neuter"></i>
              <p>fa-neuter</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="newspaper-o"></i>
              <p>fa-newspaper-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="object-group"></i>
              <p>fa-object-group</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="object-ungroup"></i>
              <p>fa-object-ungroup</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="outdent"></i>
              <p>fa-outdent</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="paint-brush"></i>
              <p>fa-paint-brush</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="paper-plane"></i>
              <p>fa-paper-plane</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="paper-plane-o"></i>
              <p>fa-paper-plane-o</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="paperclip"></i>
              <p>fa-paperclip</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="paragraph"></i>
              <p>fa-paragraph</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="paste"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="pause"></i>
              <p>fa-pause</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="pause-circle"></i>
              <p>fa-pause-circle</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="pause-circle-o"></i>
              <p>fa-pause-circle-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="paw"></i>
              <p>fa-paw</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="paypal"></i>
              <p>fa-paypal</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="pencil"></i>
              <p>fa-pencil</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="pencil-square"></i>
              <p>fa-pencil-square</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="pencil-square-o"></i>
              <p>fa-pencil-square-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="percent"></i>
              <p>fa-percent</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="phone"></i>
              <p>fa-phone</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="phone-square"></i>
              <p>fa-phone-square</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="photo"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="picture-o"></i>
              <p>fa-picture-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="pie-chart"></i>
              <p>fa-pie-chart</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="pied-piper"></i>
              <p>fa-pied-piper</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="pied-piper-alt"></i>
              <p>fa-pied-piper-alt</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="pied-piper-pp"></i>
              <p>fa-pied-piper-pp</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="pinterest"></i>
              <p>fa-pinterest</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="pinterest-p"></i>
              <p>fa-pinterest-p</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="pinterest-square"></i>
              <p>fa-pinterest-square</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="plane"></i>
              <p>fa-plane</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="play"></i>
              <p>fa-play</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="play-circle"></i>
              <p>fa-play-circle</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="play-circle-o"></i>
              <p>fa-play-circle-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="plug"></i>
              <p>fa-plug</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="plus"></i>
              <p>fa-plus</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="plus-circle"></i>
              <p>fa-plus-circle</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="plus-square"></i>
              <p>fa-plus-square</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="plus-square-o"></i>
              <p>fa-plus-square-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="podcast"></i>
              <p>fa-podcast</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="power-off"></i>
              <p>fa-power-off</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="print"></i>
              <p>fa-print</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="product-hunt"></i>
              <p>fa-product-hunt</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="puzzle-piece"></i>
              <p>fa-puzzle-piece</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="qq"></i>
              <p>fa-qq</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="qrcode"></i>
              <p>fa-qrcode</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="question"></i>
              <p>fa-question</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="question-circle"></i>
              <p>fa-question-circle</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="question-circle-o"></i>
              <p>fa-question-circle-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="quora"></i>
              <p>fa-quora</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="quote-left"></i>
              <p>fa-quote-left</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="quote-right"></i>
              <p>fa-quote-right</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="ra"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="random"></i>
              <p>fa-random</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="ravelry"></i>
              <p>fa-ravelry</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="rebel"></i>
              <p>fa-rebel</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="recycle"></i>
              <p>fa-recycle</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="reddit"></i>
              <p>fa-reddit</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="reddit-alien"></i>
              <p>fa-reddit-alien</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="reddit-square"></i>
              <p>fa-reddit-square</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="refresh"></i>
              <p>fa-refresh</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="registered"></i>
              <p>fa-registered</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="remove"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="renren"></i>
              <p>fa-renren</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="reorder"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="repeat"></i>
              <p>fa-repeat</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="reply"></i>
              <p>fa-reply</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="reply-all"></i>
              <p>fa-reply-all</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="resistance"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="retweet"></i>
              <p>fa-retweet</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="rmb"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="road"></i>
              <p>fa-road</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="rocket"></i>
              <p>fa-rocket</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="rotate-left"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="rotate-right"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="rouble"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="rss"></i>
              <p>fa-rss</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="rss-square"></i>
              <p>fa-rss-square</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="rub"></i>
              <p>fa-rub</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="ruble"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="rupee"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="s15"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="safari"></i>
              <p>fa-safari</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="save"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="scissors"></i>
              <p>fa-scissors</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="scribd"></i>
              <p>fa-scribd</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="search"></i>
              <p>fa-search</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="search-minus"></i>
              <p>fa-search-minus</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="search-plus"></i>
              <p>fa-search-plus</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="sellsy"></i>
              <p>fa-sellsy</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="send"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="send-o"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="server"></i>
              <p>fa-server</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="share"></i>
              <p>fa-share</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="share-alt"></i>
              <p>fa-share-alt</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="share-alt-square"></i>
              <p>fa-share-alt-square</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="share-square"></i>
              <p>fa-share-square</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="share-square-o"></i>
              <p>fa-share-square-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="shekel"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="sheqel"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="shield"></i>
              <p>fa-shield</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="ship"></i>
              <p>fa-ship</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="shirtsinbulk"></i>
              <p>fa-shirtsinbulk</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="shopping-bag"></i>
              <p>fa-shopping-bag</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="shopping-basket"></i>
              <p>fa-shopping-basket</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="shopping-cart"></i>
              <p>fa-shopping-cart</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="shower"></i>
              <p>fa-shower</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="sign-in"></i>
              <p>fa-sign-in</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="sign-language"></i>
              <p>fa-sign-language</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="sign-out"></i>
              <p>fa-sign-out</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="signal"></i>
              <p>fa-signal</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="signing"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="simplybuilt"></i>
              <p>fa-simplybuilt</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="sitemap"></i>
              <p>fa-sitemap</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="skyatlas"></i>
              <p>fa-skyatlas</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="skype"></i>
              <p>fa-skype</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="slack"></i>
              <p>fa-slack</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="sliders"></i>
              <p>fa-sliders</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="slideshare"></i>
              <p>fa-slideshare</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="smile-o"></i>
              <p>fa-smile-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="snapchat"></i>
              <p>fa-snapchat</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="snapchat-ghost"></i>
              <p>fa-snapchat-ghost</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="snapchat-square"></i>
              <p>fa-snapchat-square</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="snowflake-o"></i>
              <p>fa-snowflake-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="soccer-ball-o"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="sort"></i>
              <p>fa-sort</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="sort-alpha-asc"></i>
              <p>fa-sort-alpha-asc</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="sort-alpha-desc"></i>
              <p>fa-sort-alpha-desc</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="sort-amount-asc"></i>
              <p>fa-sort-amount-asc</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="sort-amount-desc"></i>
              <p>fa-sort-amount-desc</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="sort-asc"></i>
              <p>fa-sort-asc</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="sort-desc"></i>
              <p>fa-sort-desc</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="sort-down"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="sort-numeric-asc"></i>
              <p>fa-sort-numeric-asc</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="sort-numeric-desc"></i>
              <p>fa-sort-numeric-desc</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="sort-up"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="soundcloud"></i>
              <p>fa-soundcloud</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="space-shuttle"></i>
              <p>fa-space-shuttle</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="spinner"></i>
              <p>fa-spinner</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="spoon"></i>
              <p>fa-spoon</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="spotify"></i>
              <p>fa-spotify</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="square"></i>
              <p>fa-square</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="square-o"></i>
              <p>fa-square-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="stack-exchange"></i>
              <p>fa-stack-exchange</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="stack-overflow"></i>
              <p>fa-stack-overflow</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="star"></i>
              <p>fa-star</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="star-half"></i>
              <p>fa-star-half</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="star-half-empty"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="star-half-full"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="star-half-o"></i>
              <p>fa-star-half-o</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="star-o"></i>
              <p>fa-star-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="steam"></i>
              <p>fa-steam</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="steam-square"></i>
              <p>fa-steam-square</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="step-backward"></i>
              <p>fa-step-backward</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="step-forward"></i>
              <p>fa-step-forward</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="stethoscope"></i>
              <p>fa-stethoscope</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="sticky-note"></i>
              <p>fa-sticky-note</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="sticky-note-o"></i>
              <p>fa-sticky-note-o</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="stop"></i>
              <p>fa-stop</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="stop-circle"></i>
              <p>fa-stop-circle</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="stop-circle-o"></i>
              <p>fa-stop-circle-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="street-view"></i>
              <p>fa-street-view</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="strikethrough"></i>
              <p>fa-strikethrough</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="stumbleupon"></i>
              <p>fa-stumbleupon</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="stumbleupon-circle"></i>
              <p>fa-stumbleupon-circle</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="subscript"></i>
              <p>fa-subscript</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="subway"></i>
              <p>fa-subway</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="suitcase"></i>
              <p>fa-suitcase</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="sun-o"></i>
              <p>fa-sun-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="superpowers"></i>
              <p>fa-superpowers</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="superscript"></i>
              <p>fa-superscript</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="support"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="table"></i>
              <p>fa-table</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="tablet"></i>
              <p>fa-tablet</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="tachometer"></i>
              <p>fa-tachometer</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="tag"></i>
              <p>fa-tag</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="tags"></i>
              <p>fa-tags</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="tasks"></i>
              <p>fa-tasks</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="taxi"></i>
              <p>fa-taxi</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="telegram"></i>
              <p>fa-telegram</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="television"></i>
              <p>fa-television</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="tencent-weibo"></i>
              <p>fa-tencent-weibo</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="terminal"></i>
              <p>fa-terminal</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="text-height"></i>
              <p>fa-text-height</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="text-width"></i>
              <p>fa-text-width</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="th"></i>
              <p>fa-th</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="th-large"></i>
              <p>fa-th-large</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="th-list"></i>
              <p>fa-th-list</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="themeisle"></i>
              <p>fa-themeisle</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="thermometer"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="thermometer-0"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="thermometer-1"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="thermometer-2"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="thermometer-3"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="thermometer-4"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="thermometer-empty"></i>
              <p>fa-thermometer-empty</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="thermometer-full"></i>
              <p>fa-thermometer-full</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="thermometer-half"></i>
              <p>fa-thermometer-half</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="thermometer-quarter"></i>
              <p>fa-thermometer-quarter</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="thermometer-three-quarters"></i>
              <p>fa-thermometer-three-quarters</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="thumb-tack"></i>
              <p>fa-thumb-tack</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="thumbs-down"></i>
              <p>fa-thumbs-down</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="thumbs-o-down"></i>
              <p>fa-thumbs-o-down</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="thumbs-o-up"></i>
              <p>fa-thumbs-o-up</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="thumbs-up"></i>
              <p>fa-thumbs-up</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="ticket"></i>
              <p>fa-ticket</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="times"></i>
              <p>fa-times</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="times-circle"></i>
              <p>fa-times-circle</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="times-circle-o"></i>
              <p>fa-times-circle-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="times-rectangle"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="times-rectangle-o"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="tint"></i>
              <p>fa-tint</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="toggle-down"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="toggle-left"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="toggle-off"></i>
              <p>fa-toggle-off</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="toggle-on"></i>
              <p>fa-toggle-on</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="toggle-right"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="toggle-up"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="trademark"></i>
              <p>fa-trademark</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="train"></i>
              <p>fa-train</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="transgender"></i>
              <p>fa-transgender</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="transgender-alt"></i>
              <p>fa-transgender-alt</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="trash"></i>
              <p>fa-trash</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="trash-o"></i>
              <p>fa-trash-o</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="tree"></i>
              <p>fa-tree</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="trello"></i>
              <p>fa-trello</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="tripadvisor"></i>
              <p>fa-tripadvisor</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="trophy"></i>
              <p>fa-trophy</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="truck"></i>
              <p>fa-truck</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="try"></i>
              <p>fa-try</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="tty"></i>
              <p>fa-tty</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="tumblr"></i>
              <p>fa-tumblr</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="tumblr-square"></i>
              <p>fa-tumblr-square</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="turkish-lira"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="tv"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="twitch"></i>
              <p>fa-twitch</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="twitter"></i>
              <p>fa-twitter</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="twitter-square"></i>
              <p>fa-twitter-square</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="umbrella"></i>
              <p>fa-umbrella</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="underline"></i>
              <p>fa-underline</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="undo"></i>
              <p>fa-undo</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="universal-access"></i>
              <p>fa-universal-access</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="university"></i>
              <p>fa-university</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="unlink"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="unlock"></i>
              <p>fa-unlock</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="unlock-alt"></i>
              <p>fa-unlock-alt</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="unsorted"></i>
              <p></p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="upload"></i>
              <p>fa-upload</p>
            </div>
          </div>

          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="usb"></i>
              <p>fa-usb</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="usd"></i>
              <p>fa-usd</p>
            </div>
          </div>

          <div class="col-md-2">

            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="user"></i>
              <p>fa-user</p>
            </div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="user-circle"></i>
              <p>fa-user-circle</p>
            </div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="user-circle-o"></i>
              <p>fa-user-circle-o</p>
            </div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="user-md"></i>
              <p>fa-user-md</p>
            </div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="user-o"></i>
              <p>fa-user-o</p>
            </div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="user-plus"></i>
              <p>fa-user-plus</p>
            </div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="user-secret"></i>
              <p>fa-user-secret</p>
            </div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="user-times"></i>
              <p>fa-user-times</p>
            </div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="users"></i>
              <p>fa-users</p>
            </div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="vcard"></i>
              <p></p>
            </div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="vcard-o"></i>
              <p></p>
            </div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="venus"></i>
              <p>fa-venus</p>
            </div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="venus-double"></i>
              <p>fa-venus-double</p>
            </div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="venus-mars"></i>
              <p>fa-venus-mars</p>
            </div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="viacoin"></i>
              <p>fa-viacoin</p>
            </div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="viadeo"></i>
              <p>fa-viadeo</p>
            </div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="viadeo-square"></i>
              <p>fa-viadeo-square</p>
            </div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="video-camera"></i>
              <p>fa-video-camera</p>
            </div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="vimeo"></i>
              <p>fa-vimeo</p>
            </div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="vimeo-square"></i>
              <p>fa-vimeo-square</p>
            </div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="vine"></i>
              <p>fa-vine</p>
            </div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="vk"></i>
              <p>fa-vk</p>
            </div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="volume-control-phone"></i>
              <p>fa-volume-control-phone</p>
            </div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="volume-down"></i>
              <p>fa-volume-down</p>
            </div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="volume-off"></i>
              <p>fa-volume-off</p>
            </div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="volume-up"></i>
              <p>fa-volume-up</p>
            </div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="warning"></i>
              <p>fa-warning</p>
            </div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="wheelchair"></i>
              <p>fa-wheelchair</p>
            </div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="wifi"></i>
              <p>fa-wifi</p>
            </div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="window-maximize"></i>
              <p>fa-window-maximize</p>
            </div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="window-minimize"></i>
              <p>fa-window-minimize</p>
            </div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="window-restore"></i>
              <p>fa-window-restore</p>
            </div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="won"></i>
              <p>fa-won</p>
            </div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="wrench"></i>
              <p>fa-wrench</p>
            </div>
          </div>
          <div class="col-md-2">
            <div class="font-icon-wrapper"><i class="fa fa-fw" aria-hidden="true" title="yen"></i>
              <p>fa-yen</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
